import { render } from "./Locations.vue?vue&type=template&id=c4fcd890"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__